import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";
import { TooltipItem } from "src/utils/Tooltip";

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    errors?: any;
    value: string;
}

function NumberInput(props: Props) {
    const { dataField, onChange, errors, value } = props;

    return (
        <div className={`${dataField.width} mb-5`}>
            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                    <>&nbsp;&nbsp;<InfoIcon /></>
                </TooltipItem>}</span>
                {dataField.require && (
                    <div className="flex flex-row justify-between">
                        {Object.keys(errors).length > 0 && errors[dataField.key] && (
                            <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                        )}
                        <span className="text-[#BA0C2F]">*</span>
                    </div>
                )}
            </label>
            <div className="mt-2">
                <input
                    type="number"
                    autoComplete=""
                    value={Number(value)}
                    min={0}
                    disabled={dataField.disabled}
                    onChange={onChange}
                    placeholder={dataField.placeholder}
                    className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]`}
                />
            </div>
        </div>
    );
}

export default NumberInput;
